import { Injectable, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TitleStrategy } from '@angular/router';
import { ConfigurationService } from './configuration.service';

@Injectable({ providedIn: 'root' })
export class TemplatePageTitleStrategyService extends TitleStrategy {
  private readonly configurationService = inject(ConfigurationService);
  private readonly title = inject(Title);

  override updateTitle() {
    const appName = this.configurationService.configuration.appName ?? 'Local';
    this.title.setTitle(appName + ' Online Group Sales');
  }
}
